module.exports = __webpack_public_path__ + "static/media/macarons.7b3eb64b.jpg";